// extracted by mini-css-extract-plugin
export default {"link_post_container":"social-shelf-items-ShelfLinkPostSection__link_post_container--2-VUe"};